<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { DecisionProjectBuilderViewModel } from '@Projects/Components/DecisionProjectBuilder';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class DecisionProjectBuilder extends Vue
    {
        get vm(): DecisionProjectBuilderViewModel { return this.$props.viewModel as DecisionProjectBuilderViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        
        get creating(): boolean { return this.vm.creating; }

        get name(): string | null { return this.vm.name; }
        set name(val: string | null) { this.vm.name = val; }

        get description(): string | null { return this.vm.description; }
        set description(val: string | null) { this.vm.description = val; }

        get nameError(): string | null { return this.vm.nameError; }
        get descriptionError(): string | null { return this.vm.descriptionError; }

        handleFormSubmit()
        {
            this.vm.creating = true;
            this.$emit("create-decision", this.name, this.description);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create decision</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="decision-project-builder-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Decision name:</label>
                                <input v-model.trim="name" type="text" class="form-control" required minlength="2" maxlength="100">
                                <div v-if="nameError" class="error">{{nameError}}</div>
                            </div>

                            <div class="form-group">
                                <label>Description (optional):</label>
                                <textarea v-model.trim="description" class="form-control"></textarea>
                                <div class="error">{{descriptionError}}</div>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer text-right">
                        <button type="button" @click="close" :disabled="creating"  class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="decision-project-builder-form" :disabled="creating"  class="btn btn-primary">
                            {{creating ? 'Creating...' : 'Create'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

